import { gql } from "@outschool/ui-apollo";

export const SavedActivityFragment = gql`
  fragment SavedActivityFragment on SavedActivity {
    uid
    activity_uid
    created_at
  }
`;
